/**
 * Created by Arison on 2019/7/16.
 */
export const CHANGE_PAY_TAB_SELECT= 'CHANGE_PAY_TAB_SELECT';